import React, { useEffect } from "react";
import {
  DownloadButton,
  TopHeading,
  Wrapper,
} from "../../../common/index.style";
import OnboardingRequestsDataTableAG from "../../../components/table/OnboardingRequestsDataTableAG";
import { DataContent } from "../publishers/index.style";
import { useDispatch, useSelector } from "react-redux";
import { getOnboardingRequests } from "../../../redux/onboardingSlice";
import { CSVLink } from "react-csv";
import { Row, Col } from "antd";
import moment from "moment";

const csvHeaders = [
  { label: "Date Requested", key: "createdAt" },
  { label: "CMS", key: "platform" },
  { label: "Name", key: "name" },
  { label: "Email", key: "email" },
  { label: "Website", key: "website" },
  { label: "Country", key: "country" },
  { label: "Currency", key: "currency" },
  { label: "Price / Article", key: "pricePerArticle" },
  { label: "Referred By", key: "referredBy" },
  { label: "Ghost Admin API Key", key: "ghostAdminApiKey" },
  { label: "Ghost API URL", key: "ghostApiUrl" },
  { label: "beehiiv Publication ID", key: "beehiivPublicationId" },
  { label: "beehiiv API Key", key: "beehiivApiKey" },
];

const formatCsvData = (requests) =>
  (requests ?? []).map((r) => ({
    ...r,
    createdAt: r.createdAt ? moment(r.createdAt).format("l LT") : "",
    referredBy: r.referredBy ?? "",
    ghostAdminApiKey: r.ghostAdminApiKey ?? "",
    ghostApiUrl: r.ghostApiUrl ?? "",
    beehiivPublicationId: r.beehiivPublicationId ?? "",
    beehiivApiKey: r.beehiivApiKey ?? "",
  }));

const OnboardingRequests = () => {
  const dispatch = useDispatch();
  const { allOnboardingRequests, loading } = useSelector(
    (store) => store.onboarding
  );

  useEffect(() => {
    dispatch(getOnboardingRequests());
  }, [dispatch]);

  const csvData = formatCsvData(allOnboardingRequests);

  return (
    <Wrapper>
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <TopHeading style={{ margin: 0 }}>Onboarding Requests</TopHeading>
        </Col>
        <Col>
          <CSVLink
            filename="onboarding-requests"
            data={csvData}
            headers={csvHeaders}
          >
            <DownloadButton>Download</DownloadButton>
          </CSVLink>
        </Col>
      </Row>
      <DataContent>
        <OnboardingRequestsDataTableAG
          requests={allOnboardingRequests}
          loading={loading}
        />
      </DataContent>
    </Wrapper>
  );
};

export default OnboardingRequests;
